module.exports = __webpack_public_path__ + "static/media/m_hairstyle_slickedback_front.6e2da69e.png";